/* jshint esversion: 6 */
/* jshint ignore:start */
import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
    const { t } = useTranslation();

    return createPortal(
        <div className="-mt-[80px] h-[100vh] flex items-center justify-center bg-white overflow-hidden">
            <div className="text-center">
                <h1 className="text-6xl font-bold">404</h1>
                <h2 className="text-2xl">{t("Page Not Found")}</h2>
                <h4 className="mt-4 text-lg">{t("Sorry, the page you are looking for does not exist.")}</h4>
            </div>
        </div>,
        document.getElementById('portal-root')
    );
};

export default NotFound;
/* jshint ignore:end */